var React = require('react');

function BlindsOpen (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96,64H16L0,112H96Zm0,146.94V192H16L0,240H66.94A48.06,48.06,0,0,1,96,210.94ZM496,64H128v48H512ZM16,320,0,368H512l-16-48Zm0,144L0,512H512l-16-48ZM128,192v18.94A48.06,48.06,0,0,1,157.06,240H512l-16-48Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512,16V48a16,16,0,0,1-16,16H128V210.94a48,48,0,1,1-32,0V64H16A16,16,0,0,1,0,48V16A16,16,0,0,1,16,0H496A16,16,0,0,1,512,16Z","className":"fa-primary","key":2})]);
}

BlindsOpen.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = BlindsOpen;

BlindsOpen.default = BlindsOpen;
